import { BoImageBaseDto, BoImageUpdateDto } from "../internal/BoImageDto";
import { BoConfigurationStatusBaseDto } from "./BoConfigurationStatusDto";

export enum BoFreeAreaEnum {
        Area1 = 1,
        Area2 = 2,
        Area3 = 3,
}

export class BoFreeAreaBaseDto {
        id!: string;
        eventId!: string;
        configurationStatus!: BoConfigurationStatusBaseDto;

        area!: BoFreeAreaEnum;
        title?: string | null;
        text?: string | null;
        textBeforeImage?: boolean;

        image1Id?: string;
        image1?: BoImageBaseDto | null;

        image2Id?: string;
        image2?: BoImageBaseDto | null;

        image3Id?: string;
        image3?: BoImageBaseDto | null;

        constructor(init?: Partial<BoFreeAreaUpdateDto>) {
                Object.assign(this, init);
        }
}

export class BoFreeAreaUpdateDto {
        id!: string;

        title?: string | null;
        text?: string | null;
        textBeforeImage?: boolean;

        updateImage1?: BoImageUpdateDto | null;
        updateImage2?: BoImageUpdateDto | null;
        updateImage3?: BoImageUpdateDto | null;


        constructor(init?: Partial<BoFreeAreaUpdateDto>) {
                Object.assign(this, init);
        }
}


